export default "__VITE_ASSET__CcKWw8PY__"